import { DirectiveOptions } from 'vue';

const textDecorate: DirectiveOptions = {
    inserted: (el, binding) => {
        const text = el.innerText;
        const lastIndexOf = text.lastIndexOf(' ');
        if (lastIndexOf > 0) {
            const textWithoutLastWord = text.substring(0, lastIndexOf + 1);
            const lastWord = text.substring(lastIndexOf + 1, text.length);
            el.innerHTML = textWithoutLastWord;
            const span = document.createElement('span');
            span.innerHTML = lastWord;
            span.classList.add('color-primary');
            el.appendChild(span);
        }
    },
};

export default textDecorate;
